import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { LOGIN } from 'constants/appRouting'
import { userLogout } from 'reducers/profile/reducer'

function Logout({ userLogout }) {
  useEffect(() => () => {
    localStorage.removeItem('referrer')
    userLogout()
  })

  return <Redirect to={LOGIN} />
}

Logout.propTypes = {
  userLogout: PropTypes.func.isRequired,
}

export default connect(null, {
  userLogout,
})(Logout)
